export const styles = {
    gridContainerBase: {
        margin: 0,
        paddingTop: 1,
        flexWrap: "nowrap",
        columnGap: 2,
        wordBreak: "break-word"
    },
    typography: {
        color: ({ palette }) => palette.greyscale[900]
    },
    gridstatus: {
        position: "relative"
    },
    gridItemBase: {
        display: "flex",
        flexDirection: "column"
    },
    svgIcon: {
        color: "transparent",
        height: 16,
        width: 16
    }
};